import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import View from "components/elements/View";
import { useGetManagementStudyDatesQuery } from "store/datesManagement";
import moment, { Moment } from "moment";
import DatesManagementForm from "views/App/views/DatesManagement/components";

interface FormValuesType {
  [key: string]: Moment;
}

function DatesManagement(): JSX.Element {
  const { t } = useTranslation();
  const [initialValues, setInitialValues] = useState<FormValuesType | null>(
    null
  );
  const { data, isLoading, isFetching, refetch } =
    useGetManagementStudyDatesQuery();

  useEffect(() => {
    if (data) {
      const preparedData: FormValuesType = {};
      data?.forEach((item) => {
        preparedData[item.id] = moment(item.date, "YYYY-MM-DD");
      });
      setInitialValues(preparedData);
    }
  }, [data]);

  const refetchData = () => {
    setInitialValues(null);
    refetch();
  };

  return (
    <View
      title={t("dates_management.title")}
      isLoading={isLoading || isFetching}
    >
      {data && initialValues ? (
        <DatesManagementForm
          initialValues={initialValues}
          data={data}
          refetchData={refetchData}
        />
      ) : null}
    </View>
  );
}

export default DatesManagement;
